<template>
  <div class="wrapper">
    <side-bar background-color="white">
      <template slot="links">
        <sidebar-link to="/home" name="Αρχική" icon="ti-home"/>
        <sidebar-link to="/profile" name="Λογαριασμός" icon="ti-user"/>
        <sidebar-link to="/invoice" name="Παραστατικό" icon="ti-receipt"/>
        <sidebar-link to="/plans" name="Συνδρομές" icon="ti-layout-grid2"/>
        <sidebar-link to="/payments" name="Πληρωμές" icon="ti-money"/>
        <!-- <sidebar-link to="/table-list" name="Table List" icon="ti-view-list-alt"/>
        <sidebar-link to="/typography" name="Typography" icon="ti-text"/>
        <sidebar-link to="/icons" name="Icons" icon="ti-pencil-alt2"/>
        <sidebar-link to="/maps" name="Map" icon="ti-map"/>
        <sidebar-link to="/notifications" name="Notifications" icon="ti-bell"/> -->
      </template>
      <mobile-menu>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down> -->
        <li class="nav-item">
            <a href="javascript:void(0);" class="nav-link">
              <i class="ti-user"></i>
              <p>
                {{ ($root.getLoggedUser()) ? $root.getLoggedUser().email : '' }}
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a v-if="$root.canUserDo(['logout'])" href="#!" class="nav-link" @click="$root.logout();">
              <i class="ti-power-off"></i>
              <p>Αποσύνδεση</p>
            </a>
            <span v-else style="cursor: not-allowed;" class="nav-item text-muted">
              <i class="ti-power-off"></i>
              <p>Αποσύνδεση</p>  
            </span>
          </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
